import { LayoutPageSectionShell } from 'components/authorable/layout/LayoutPageSection/LayoutPageSection';
import { LayoutLeftThirdShell } from 'components/authorable/layout/LayoutLeftThird/LayoutLeftThird';
import ProductListFacets from 'components/helpers/AlgoliaSearch/NetworkResourceCenter/ProductList/ProductListFacets';
import ProductListStats from 'components/helpers/AlgoliaSearch/NetworkResourceCenter/ProductList/ProductListStats';
import { classnames } from 'tailwindcss-classnames';
import ProductListResults from 'components/helpers/AlgoliaSearch/NetworkResourceCenter/ProductList/ProductListResults';
import ProductListSort from 'components/helpers/AlgoliaSearch/NetworkResourceCenter/ProductList/ProductListSort';
import { NetworkResourceCenter } from '.generated/templates/Project.NetworkResourceCenter.model';
import ProductListAlert from 'components/helpers/AlgoliaSearch/NetworkResourceCenter/ProductList/ProductListAlert';

export type ProductListPageProps = NetworkResourceCenter.ProductListing.Fields.ProductList;

const ProductListPage = ({ fields }: ProductListPageProps) => {
  return (
    <div data-component="authorable/network-resource-center/product-list-page">
      <LayoutPageSectionShell theme="theme-white">
        <div
          className={classnames(
            'flex',
            'flex-col',
            'md:items-center',
            'justify-between',
            'w-full',
            'pb-6',
            'md:flex-row',
            'lg:pt-4',
            'lg:pb-2'
          )}
        >
          <ProductListStats />
          <span className={classnames('hidden', 'lg:block')}>
            <ProductListSort />
          </span>
        </div>
        <LayoutLeftThirdShell
          left={<ProductListFacets />}
          right={
            <>
              <ProductListAlert alert={fields?.pageAlert} />
              <ProductListResults />
            </>
          }
          isSearchPage
        />
      </LayoutPageSectionShell>
    </div>
  );
};

export default ProductListPage;
